"use client";

import { usePathname } from "next/navigation";
import { MoneytizerCMP } from "@rosette/web_components/src/cookie/MoneytizerCMP.js";


export function CMPProvider() {
    const pathname = usePathname();
    const provideCMP = (pathname === "/" || pathname.startsWith("/game"));

    if (!provideCMP)
        return (<></>);

    return <MoneytizerCMP />;
}
